import React, { useState } from "react";
import { SideMenu } from "../../components/utils/SideMenu/SideMenu.container";
import { SideMenuArrowContext, SideMenuCloseArrow } from "../../components/utils/SideMenu/SideMenuCloseArrow";
import SubTopbar from "../../components/utils/SubTopbar";
import TopBar from "../../components/utils/TopBar";
import { IAccountStateProps } from "./types";
import { IState } from "../reducer";
import * as selectors from "../../selectors/selectors";
import { connect } from "react-redux";
import { UserContextComponent } from "../../context/users/UserContext";
import { UsersListWrapper } from "./UsersListWrapper";

export const AccountComponent: React.FC<IAccountStateProps> = (props): JSX.Element => {
  const { organizationName, userName } = props;

  const [menuExpanded, setMenuExpanded] = useState(true);
  const { isOpen } = React.useContext(SideMenuArrowContext);
  const toogleMenu = () => setMenuExpanded(!menuExpanded);

  return (
    <>
      <TopBar showToggleMenu={true} onToggleMenuClick={toogleMenu} userName={userName} />
      <SideMenuCloseArrow />
      <SideMenu
        expanded={menuExpanded}
        organizationName={organizationName}
        userName={userName}
        onClose={toogleMenu}
        isOpen={isOpen}
      />
      <SubTopbar withSidebar={true} isOpen={isOpen}>
        <UserContextComponent
          isOrgAdmin={props.isOrgAdmin}
          accountId={props.accountId}
          organizationId={props.organizationId}
        >
          <UsersListWrapper accountId={props.accountId} />
        </UserContextComponent>
      </SubTopbar>
    </>
  );
};

const mapStateToProps = (state: IState): IAccountStateProps => ({
  accountId: selectors.accountId(state),
  isOrgAdmin: selectors.isOrgAdmin(state),
  organizationId: selectors.organizationId(state),
  organizationName: selectors.organizationName(state),
  userName: selectors.accountName(state),
});

export const AccountList = connect(mapStateToProps)(AccountComponent);
